// 用户相关
export default [
    // 永久注销账号
    {
        path: '/user/signOutForever',
        redirect: 'user/signOutForever/index',
        component: () => import(/* webpackChunkName:"user-signOutForever"*/'@/pages/user/signOutForever/parent.vue'),
        meta: {
            title: '永久注销账号',
        },
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"user-signOutForever"*/'@/pages/user/signOutForever/index.vue'),
                name: 'user/signOutForever/index',
            },
            {
                path: 'result',
                component: () => import(/* webpackChunkName:"user-signOutForever"*/'@/pages/user/signOutForever/result.vue'),
                name: 'user/signOutForever/result',
            },
        ],
    },
    {
        path: '/personalInfoExport',
        component: () => import(/* webpackChunkName:"user-personalInfoExport"*/'@/pages/user/personalInfoExport/index.vue'),
        name: 'PersonalInfoExport',
        meta: {
            title: '个人信息导出',
        },
    },
    {
        path: '/personalInfoExport/userExport',
        component: () => import(/* webpackChunkName:"user-personalInfoExport"*/'@/pages/user/personalInfoExport/userExport.vue'),
        name: 'UserExport',
        meta: {
            title: '个人信息浏览与导出',
        },
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName:"user-login"*/'@/pages/user/login/index.vue'),
        name: 'login',
        meta: {
            title: '会员登录',
        },
    },
    {
        path: '/sso/login',
        component: () => import(/* webpackChunkName:"sso-login"*/'@/pages/user/login/index.vue'),
        name: 'SSOLogin',
        meta: {
            title: '统一登录',
        },
    },
    {
        path: '/user/personalized',
        component: () => import('@/pages/user/personalized/index.vue'),
        name: 'personalized',
        meta: {
            title: '个性化推荐',
        },
    },
    {
        path: '/user/certificateInfo',
        component: () => import('@/pages/user/certificateInfo/index.vue'),
        name: 'certificateInfo',
        meta: {
            title: '证件信息',
            keepAlive: true,
        },
    },
    {
        path: '/user/certificateBindAppeal',
        component: () => import('@/pages/user/certificateBindAppeal/index.vue'),
        name: 'certificateBindAppeal',
        meta: {
            title: '证件绑定申诉',
            keepAlive: true,
        },
    },
    // 新客八折  预定提醒
    {
        path: '/user/certificateNewCustom',
        component: () => import('@/pages/user/certificateNewCustom/index.vue'),
        name: 'certificateNewCustom',
        meta: {
            title: '预订提醒',
            keepAlive: true,
        },
    },
];
